import { Injectable, DOCUMENT, inject, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private document = inject(DOCUMENT);
  public isLightTheme = signal(this.getInitialTheme());

  constructor() {
    this.applyInitialTheme();
  }

  private getInitialTheme(): boolean {
    try {
      const storage = localStorage.getItem('__app_storage__');
      if (storage) {
        const parsed = JSON.parse(storage);
        return parsed?.ui?.theme !== 'dark';
      }
    } catch (e) {
      console.error('Failed to parse theme from localStorage', e);
    }
    return true;
  }

  private applyInitialTheme(): void {
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = this.isLightTheme() ? 'light.css' : 'dark.css';
    }
  }

  private saveThemeToStorage(theme: 'light' | 'dark'): void {
    try {
      const storage = localStorage.getItem('__app_storage__');
      const parsed = storage ? JSON.parse(storage) : {};
      parsed.ui = { ...parsed.ui, theme };
      localStorage.setItem('__app_storage__', JSON.stringify(parsed));
    } catch (e) {
      console.error('Failed to save theme to localStorage', e);
    }
  }

  public setLightTheme(): void {
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    themeLink.href = 'light.css';
    this.isLightTheme.set(true);
    this.saveThemeToStorage('light');
  }

  public setDarkTheme(): void {
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    themeLink.href = 'dark.css';
    this.saveThemeToStorage('dark');
    this.isLightTheme.set(false);
  }
}
